import type { AllRouteEndpoints } from "../routeTypes";
export const engagementInAppMessageColorProfilesId = "/engagement/in_app_message_color_profiles(/:id)" as const;
export const engagementInAppMessageColorProfiles = "/engagement/in_app_message_color_profiles" as const;
export const engagementInAppMessageColorProfilesDefault =
  "/engagement/in_app_message_color_profiles/default" as const;

export const engagementInAppMessageColorProfilesIdCacheKeys: AllRouteEndpoints[] = [
  engagementInAppMessageColorProfilesId,
  engagementInAppMessageColorProfiles,
  engagementInAppMessageColorProfilesDefault,
];
